import { render, staticRenderFns } from "./PersonalQRCode.vue?vue&type=template&id=4fc435c2&"
import script from "./PersonalQRCode.vue?vue&type=script&lang=js&"
export * from "./PersonalQRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports